import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios,axios);

import VueSocketio from 'vue-socket.io';

Vue.use(new VueSocketio({
    debug: false,
    connection: 'https://chat.seasideworkshop.net'
}))

Vue.config.productionTip = false

new Vue({
	router,
	store,
	data: {
	},
	render: h => h(App)
}).$mount('#app')